export default {
    namespaced: true,
    state: {
        orders_vignette: null,
        orders_vignette_total: 0,
        orders_toll: null,
        orders_toll_total: 0,
        order: null,
        status: null
    },
    mutations: {
        setOrders: (state, orders) => {
            state.orders_vignette_total = orders.orders_vignette_total;
            if(orders.orders_vignette.length) {
                state.orders_vignette = orders.orders_vignette;
            }
            else {
                state.orders_vignette = null;
            }

            state.orders_toll_total = orders.orders_toll_total;
            if(orders.orders_toll.length) {
                state.orders_toll = orders.orders_toll;
            }
            else {
                state.orders_toll = null;
            }
        },

        setOrder: (state, order) => {
            state.order = order;
        },

        saveStatus: (state, status) => {
            state.status = status;
        }
    },
    actions: {
        getOrder(context, params) {
            return this.$axios.get('/orders/' + params.id + '/' + params.type)
                .then(response => {
                    if(response.data.order) {
                        context.commit('setOrder', response.data.order);
                    }

                    return response;
                });
        },

        getOrders(context, params) {
            return this.$axios.get('/orders', {params: params})
                .then(response => {
                    if(response.data.orders) {
                        context.commit('setOrders', response.data.orders);
                    }

                    return response;
                });
        },

        getOrdersStatus(context, params) {
            return this.$axios.get('/ordersSts', {params: params})
                .then(response => {
                    return response;
                })
        },

        postOrder(context, order) {
            return this.$axios.post('/orders', order)
                .then(response => {
                    return response;
                });
        },

        saveStatus({commit}, status) {
            commit('saveStatus', status);
        }
    },
    getters: {
        getOrdersVignette: (state) => {
            return state.orders_vignette;
        },

        getOrdersToll: (state) => {
            return state.orders_toll;
        },
    }
}
